import styles from "./ToggleSwitch.module.css";
import { classnames } from "../../utils/index.jsx";
import useLoader from "../../hooks/use-loader";
import { useRef, useState } from "react";
import useCanWrite from "../../hooks/use-can-write";
import { READ_ONLY_MESSAGE } from "../../utils/permissions";
import Tooltip from "./Tooltip";

export default function ToggleSwitch({
  status,
  onToggle,
  className,
  disabled,
  name,
  value,
  hasApiCall = true,
  isLoading: externalLoading = false,
  requiresWrite,
  profileId,
}) {
  const [isToggling, toggler] = useLoader(onToggle);
  const [fakeToggling, setFakeToggling] = useState(false);
  const timeoutRef = useRef(null);
  const writable = useCanWrite(profileId);
  const blocked = requiresWrite === true && !writable;

  const isLoading = isToggling || fakeToggling || externalLoading;

  function toggleHandler(e) {
    if (hasApiCall) {
      setFakeToggling(true);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setFakeToggling(false), 300);
      return toggler(e);
    }
    return onToggle(e);
  }

  const toggle = (
    <label className={classnames(styles.switch, className)}>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={status}
        onChange={toggleHandler}
        disabled={isLoading || disabled || blocked}
        className={classnames(styles.input)}
      />
      <span
        className={classnames(
          styles.slider,
          isLoading && styles.toggling,
          styles.round,
        )}
      ></span>
    </label>
  );

  if (blocked) {
    return <Tooltip content={READ_ONLY_MESSAGE}>{toggle}</Tooltip>;
  }
  return toggle;
}
